import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserModel } from '../../../models/user.model';
import { AppState } from '../../../state/appstate';
import { BtnActionComponent } from '../../components/buttons/btn-action/btn-action.component';
import { BtnBackComponent } from '../../components/buttons/btn-back/btn-back.component';
import { ListAwardsComponent } from '../../school/awards/list-awards/list-awards.component';

@Component({
  selector: 'app-my-certificates',
  standalone: true,
  imports: [
    CommonModule,
    BtnBackComponent,
    BtnActionComponent,
    ListAwardsComponent,
  ],
  templateUrl: './my-certificates.component.html',
})
export class MyCertificatesComponent implements OnInit, OnDestroy {
  @ViewChild('awardsList') awardsList?: ListAwardsComponent;

  private readonly store: Store<AppState> = inject(Store<AppState>);
  private readonly destroy$ = new Subject<void>();

  user: UserModel | null = null;

  ngOnInit(): void {
    this.store
      .select((state) => state.user.user)
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.user = user;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  refresh(): void {
    if (this.awardsList) {
      this.awardsList.refresh();
    }
  }
}
